import React from 'react';
import { shape, bool } from 'prop-types';
import { useTranslation } from 'react-i18next';

export const FeaturedMask = ({ video }) => {
  const { t } = useTranslation();

  if (!video.featured) return null;

  return (
    <div>
      <div>
        <span className="ct-featured-mask">{t('featured').toUpperCase()}</span>
      </div>
    </div>
  );
};

FeaturedMask.propTypes = {
  video: shape({
    featured: bool,
  }),
};
